import Page from '@/common-utils/components/structure/page/Page';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/common-utils/components/ui/tabs';
import Entity from '@/common-utils/components/renders/entity/Entity';
import RouteUrls from '../enums/RouteUrls';
import PartnersTable from '@/app/modules/pushPayments/components/tables/PartnersTable';
import NotifRulesTable from '@/app/modules/pushPayments/components/tables/NotifRulesTable';
import { useState } from 'react';
import PUSH_PAYMENTS_TABS from '../enums/tabs/PushPaymentsTabs';
import useTabManager from '../hooks/useTabManager';
import { useLocation, useNavigate } from 'react-router-dom';
import { extractQueriesFromUrl } from '@/common-utils/functions/restUtils';
import useSessionStore from '@/app/store/session';
import setFiltersEventName from '@/common-utils/components/renders/dataTable/utils/setFiltersEventName';

/**
 *
 * @returns {JSX} PushPayments
 */
function PushPayments() {

    // URL Params
    const navigate = useNavigate();
    const location = useLocation();
    const { view } = extractQueriesFromUrl(location.search);

    // Store
    const { permissions } = useSessionStore(s => s.session) ?? {};

    // State
    const [activeTab, setActiveTab] = useState(Object.values(PUSH_PAYMENTS_TABS).find(tab => tab.name === view)?.name ?? PUSH_PAYMENTS_TABS.DEFAULT.name);

    // Hooks
    useTabManager({
        pathname: location.pathname,
        view: view,
        activeTab: activeTab,
        setActiveTab: setActiveTab,
        tabs: PUSH_PAYMENTS_TABS,
        navigate: navigate
    });

    return (
        <Page>
            <Tabs value={activeTab} onValueChange={setActiveTab}>
                <Page.Header
                    route={RouteUrls.PUSH_PAYMENTS}
                    routeBase={RouteUrls.PUSH_PAYMENTS}
                >
                    <TabsList>
                        <TabsTrigger tab={PUSH_PAYMENTS_TABS.PARTNERS} activeTab={activeTab} permissions={permissions} >
                            <Entity entity='page.push_payments.tabs.partners' />
                        </TabsTrigger>
                        <TabsTrigger tab={PUSH_PAYMENTS_TABS.NOTIF_RULES} activeTab={activeTab} permissions={permissions} >
                            <Entity entity='page.push_payments.tabs.notif_rules' />
                        </TabsTrigger>
                    </TabsList>
                </Page.Header>
                <Page.Body dataCy='page-push-payments'>
                    <TabsContent tab={PUSH_PAYMENTS_TABS.PARTNERS} permissions={permissions}>
                        <PartnersTable filtersEventName={setFiltersEventName('partners')} />
                    </TabsContent>
                    <TabsContent tab={PUSH_PAYMENTS_TABS.NOTIF_RULES} permissions={permissions}>
                        <NotifRulesTable filtersEventName={setFiltersEventName('notif_rules')} />
                    </TabsContent>
                </Page.Body>
            </Tabs>
        </Page>
    );
}

export default PushPayments;
